<template>
  <div class="wg-row" style="justify-content:center;height:calc(100vh - 60px);">
    <div v-if="loading" class="wg-row" style="margin:10px;justify-content:center;">
      <vue-simple-spinner size="medium" line-fg-color="rgb(136, 237, 124)"/>
    </div>
    <world-sub-menu 
        v-else
        :selected="pageId"
        :list="list"
        :restrictions="mode === 'new' || mode === 'copy' ? ['details'] : []"
        @changePage="changePage">
      <div slot="content" class="wg-row component-container">
        <component 
            v-if="!loading" 
            @changePage="changePage" 
            :data="dataToPass" 
            :is="selected"></component>
        <!-- Prossima scheda -->
        <div v-if="mode !== 'new' && mode !== 'copy'" class="wg-row wg-xs-12 wg-lg-7 next-page-div">
          <input 
              type="button" 
              class="com-anm22-button-blue"
              :value="nextElem.label + ' >'" 
              @click="goToNext">
        </div>
      </div>
    </world-sub-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WorldSubMenu from "../../../../world/spa/components/WorldSubMenu.vue";
import ProjectComponents from "../components/project/settings/index";
import Spinner from "vue-simple-spinner";

export default {
  data() {
    return {
      mode: "",
      selected: "ProjectDetails",
      pageId: "details",
      projectId: 0,
      loading: true,
      // Per creazione, passati come parametri di $route, servono in caso di responsabile cliente
      workId: null,
      customerId:null
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      offline: state => state.offline.isOffline
    }),
    project() {
      if (this.mode == "edit") {
        return this.$store.getters["projects/get"](this.projectId) || {};
      } else {
        return {};
      }
    },
    licenses() {
      if(this.mode == 'edit' && this.project.developers) {
        return this.$store.getters['employments/getByUser'](this.user.idWorldUser)
          .filter(e => this.project.developers.includes(e.work))
          .map(e => this.$store.getters['licenses/getByWork'](e.work))
          .filter(l => l);
      } else {
        return [];
      }
    },
    dataToPass() {
      let obj = {
        mode: this.mode,
        workId: this.workId,
        project: { ...this.project },
        customerManager: this.customerManager,
      };
      if (this.mode === "copy") {
        obj.toCopy = this.$route.params.projectToCopy;
        obj.copyConditions = this.$route.params.copyConditions;
      }
      if(this.customerId){
        obj.customerId = this.customerId;
      }
      return obj;
    },
    userPermission() {
      return (
        this.$store.getters["employments/getPermByProject"](this.project) || 10
      );
    },
    customerManager() {
      let result = false;
      if(this.project && this.project.developers) {
        this.project.developers.forEach(work => {
          const e = this.$store.getters["employments/get"](this.user.idWorldUser+'-'+work);
          if(e && e.clients.reduce(
            (res, c) => res || (this.project.customers.includes(c.contact) && c.isManager), 
            false
          )) {
            result = true;
          }
        });
      }
      return result;
    },
    hiddenTabs() {
      const ht = new Set();
      this.licenses.forEach(l => {
        if(l.config 
            && l.config.tasks 
            && l.config.tasks.project 
            && l.config.tasks.project['hidden-edit-tabs']) {
          l.config.tasks.project['hidden-edit-tabs'].forEach(t => ht.add(t));
        }
      })
      return [...ht];
    },
    list() {
      let list = [
        {
          id: "details",
          img: this.$anm22.icons.getWorldIcon("edit"),
          label: this.$anm22.strLang(this.lang, "Details", "Dettagli"),
          component: 'ProjectDetails'
        },
        {
          id: "customers",
          img: this.$anm22.icons.getWorldIcon("workContact"),
          label: this.$anm22.strLang(this.lang, "Customers", "Clienti"),
          component: 'ProjectCustomers'
        },
        {
          id: "developers",
          img: this.$anm22.icons.getWorldIcon("workMaterial"),
          label: this.$anm22.strLang(
            this.lang,
            "Developers",
            "Aziende sviluppatrici"
          ),
          component: 'ProjectDevelopers'
        },
        {
          id: "users",
          img: this.$anm22.icons.getWorldIcon("group"),
          label: this.$anm22.strLang(this.lang, "Users", "Utenti"),
          component: 'ProjectUsers'
        },
        {
          id: "place",
          img: this.$anm22.icons.getWorldIcon("placeBlack"),
          label: this.$anm22.strLang(this.lang, "Place", "Luogo"),
          component: 'ProjectPlace'
        }
      ];
      //Check for pricing tabs ----- ONLY ONLINE
      if(!this.offline) {
        this.licenses.forEach(l => {
          // Add list element
          if(l.config && l.config.tasks && l.config.tasks.project && l.config.tasks.project.pricing) {
            const work = this.$store.getters['works/get'](l.work);
            list.push({
              id: "pricing-" + l.work,
              img: this.$anm22.icons.getWorldIcon("card"),
              label: this.$anm22.strLang(
                this.lang,
                "Pricing - " + work.name,
                "Condizioni economiche - " + work.name
              ),
              component: () => import("../components/custom/" + l.config.tasks.project.pricing)
            })
          }
        });
      }
      list.push({
        id: "task",
        img: this.$anm22.icons.getWorldIcon("open"),
        label: this.$anm22.strLang(
          this.lang,
          "Go to project",
          "Vai al progetto"
        ),
        link: "/project/" + this.project.idWorldProject
      });
      // check in config if list options are hidden
      return list.filter(item => !this.hiddenTabs.includes(item.id));
    },
    nextElem() {
      return this.list[this.list.findIndex(l => l.id === this.pageId) + 1];
    }
  },
  methods: {
    async initNewProject() {
      this.project.status = 1;
      this.project.name = "";
      this.project.startDate = Number(
        this.$moment()
          .utc()
          .format("X")
      );
      this.project.endDate = Number(
        this.$moment()
          .add(1, "months")
          .utc()
          .format("X")
      );
      this.project.description = "";
      if(this.workId == 474) {
        await this.$http
          .get('link/getProjectCodePreview')
          .then(response => {
            this.project.projectId = response.data.projectId;
          });
      } else {
        this.project.projectId = "";
      }
      this.project.template = false;
      //Old
      this.project.customer = "";
      this.project.developers = [];
      this.project.events = [];
      this.project.users = [];
      this.project.customers = [];
    },
    async loadData() {
      if (this.mode === "copy") {
        /* Carico il progetto da copiare */
        const projectToCopy = this.$store.getters["projects/get"](
          this.$route.params.projectToCopy
        );
        /* Inizializzo il nuovo progetto */
        Object.assign(this.project, projectToCopy);
        await this.initNewProject();
        /* Rimuovo eventuali id */
        delete this.project.idWorldProject, this.project.dbKey;
      } else {
        this.projectId = this.$route.params.id;
        //elaborazione in aggiunta a 'afterEach' hook nel router
        document.title = this.project.name + ' | ANM22 Tasks';
        this.$store.dispatch("headbar/setHeadbarTitle", this.$anm22.getProjectFullLabel(this.project));
        this.$store.dispatch(
          "headbar/setBackHref",
          "/project/" + this.project.idWorldProject
        );
      }
      this.$Progress.finish();
      this.loading = false;
      //Termino il caricamento della barra progressiva
      if (this.$route.query.page) {
        this.changePage(this.$route.query.page);
      }
    },
    loadPage() {
      switch (this.$route.name) {
        //Nuovo progetto, non ho bisogno di chiedere alcuna informazione
        case "newProject":
          this.mode = "new";
          this.workId = this.$route.params.work;
          if(this.$route.params.customerId) {
            this.customerId = this.$route.params.customerId;
          }
          this.initNewProject()
            .then(() => {
              this.$Progress.finish();
              this.loading = false;
            });
          break;
        case "copyProject":
          this.mode = "copy";
          this.workId = this.$route.params.work;
          if(this.$route.params.customerId) {
            this.customerId = this.$route.params.customerId;
          }
          //Recupero il progetto da copiare
          this.$http
            .get("project?idProject=" + this.$route.params.projectToCopy)
            .then(response => {
              if (response.data) {
                Promise.all([
                  this.$store.dispatch('projects/update', {
                    vlf: this.$vlf('projects'),
                    objs: response.data.projects
                  }),
                  ...['employments','projectCategories','works','users','contacts'].map(d => {
                    return this.$store.dispatch(d + '/update', {
                      vlf: this.$vlf(d),
                      objs: response.data[d]
                    });
                  })
                ]).then(() => {
                  this.loadData();
                });
              } else {
                this.$router.push("/");
              }
            })
            .catch(error => {
              //Offline
              /* Carico i dati dallo $store */
              Promise.all(
                ['projects','employments','projectCategories','works','users','contacts'].map(d => {
                  return this.$store.dispatch(d + '/load', this.$vlf(d));
                })
              )
              .then(() => this.loadData())
              .catch(error => console.log(error));
            });
          break;
        case "editProject":
          this.mode = "edit";
          this.$http
            .get("project?idProject=" + this.$route.params.id)
            .then(response => {
              //Controllo se il sistema mi ha restituito i dati del progetto, altrimenti torno alla home
              if (response.data) {
                Promise.all([
                  this.$store.dispatch('projects/update', {
                    vlf: this.$vlf('projects'),
                    objs: response.data.projects
                  }),
                  ...['employments','projectCategories','works','users','contacts'].map(d => {
                    return this.$store.dispatch(d + '/update', {
                      vlf: this.$vlf(d),
                      objs: response.data[d]
                    });
                  })
                ]).then(() => {
                  this.loadData();
                });
              } else {
                this.$router.push("/");
              }
            })
            .catch(error => {
              //Sono offline, recupero i dati dal db locale, anche employments e works
              Promise.all(
                ['projects','employments','projectCategories','works','users','contacts'].map(d => {
                  return this.$store.dispatch(d + '/load', this.$vlf(d));
                })
              )
              .then(() => this.loadData())
              .catch(error => console.log(error));
            });
          break;
      }
    },
    changePage(elem) {
      if(typeof elem == 'string') {
        elem = this.list.find(l => l.id === elem);
      }
      this.pageId = elem.id;
      this.selected = elem.component;
    },
    goToNext() {
      if(this.nextElem.component) {
        this.changePage(this.nextElem);
      } else {
        this.$router.push(this.nextElem.link);
      }
    }
  },
  created() {
    this.loadPage();
  },
  // Necessario perchè alla creazione di un progetto viene effettuata una nuova navigazione verso lo stesso
  // componente (con differente path) e, senza questo watcher, il componente non viene ricaricato
  watch: {
    $route(to, from) {
      this.loadPage();
    }
  },
  components: {
    WorldSubMenu,
    ...ProjectComponents,
    "vue-simple-spinner": Spinner
  }
};
</script>

<style lang="scss" scoped>
.component-container {
  padding-bottom: 10px;
}
.next-page-div {
  text-align: right;
  margin-top: 10px;
  & > div {
    flex-wrap: nowrap;
    align-items: center;
    border-radius: 5px;
    &:hover {
      background-color: #eee;
    }
    .label {
      padding: 10px;
      cursor: pointer;
    }
    img {
      opacity: 0.7;
    }
  }
}
</style>
<style lang="scss">
.project-manage-help-box {
  padding: 50px 0 30px 0;
  text-align: center;

  img {
    display: block;
    width: 80px;
    margin: 0 110px;
    opacity: 0.3;
    box-sizing: border-box;
  }
  div {
    display: block;
    margin: 20px 0;
    width: 300px;
    font-size: 14px;
  }
}
</style>